export default {
  validate(value) {
    if (!value || value.length !== 15) return false
    return this.mod9710(value) === 1
  },

  mod9710(value) {
    return value - Math.floor(value / 97) * 97
  },
  computesRequired: true
}
